
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { BlogPost } from "@/types/blogPost";

interface RelatedPostsCarouselProps {
  posts: BlogPost[];
}

export function RelatedPostsCarousel({ posts }: RelatedPostsCarouselProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <section className="mt-12 pt-8 border-t">
      <h2 className="text-2xl font-bold mb-6">Posts Relacionados</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post) => {
          const categoryInfo = (post as any).blog_categories;
          
          return (
            <Card key={post.id} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-0">
                {post.featured_image_url && (
                  <img
                    src={post.featured_image_url}
                    alt={post.title}
                    className="w-full h-48 object-cover rounded-t-lg"
                  />
                )}
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    {categoryInfo && (
                      <Badge 
                        style={{ 
                          backgroundColor: categoryInfo.color_hex,
                          borderColor: categoryInfo.border_color_hex,
                          color: categoryInfo.text_color_hex
                        }}
                        className="border text-xs"
                      >
                        {categoryInfo.name}
                      </Badge>
                    )}
                    <span className="text-xs text-gray-500">
                      {post.created_at ? formatDate(post.created_at) : ""}
                    </span>
                  </div>
                  
                  <h3 className="font-semibold text-lg mb-2 line-clamp-2">
                    {post.title}
                  </h3>
                  
                  {post.excerpt && (
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                  )}
                  
                  <Link
                    to={`/blog/${post.slug ?? post.id}`}
                    className="flex items-center justify-center gap-2 w-full border border-gray-200 rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-brand-primary hover:border-brand-primary/30 transition-colors"
                  >
                    Ler Mais
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
}
